export { run, registerFormatter } from 'dompack/extra/merge.es';
